import { PageCriteria } from '@src/main/shared/domain/page-criteria.interface';

export interface OutboxMessageCriteria extends PageCriteria {
  endDate?: string;
  initDate?: string;
  message?: string;
  recipient?: string;
  sendBy?: string;
  sendDateFrom?: string;
  sendDateTo?: string;
  sortField?: string;
  sortOrder?: number;
  subject?: string;
}

export const emptyOutboxMessageCriteria: OutboxMessageCriteria = {
  page: 0,
  size: 10,
  sortField: 'sendDate',
  sortOrder: -1,
};
